//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { CatalogSelectionModalAction } from '@catalog-ingestion/actions/catalogSelectionModalActions';
import { CATALOG_INGESTION_TYPES, CATALOG_SELECTION_MODAL_ACTIONS } from '@catalog-ingestion/constants/catalogSelectionConstants';

interface ICatalogSelectionState {
  selectedCatalogType: CATALOG_INGESTION_TYPES;
  isOpen: boolean;
  flags: {
    isSettingEcommerceType: boolean,
  };
}

const initialState: ICatalogSelectionState = {
  selectedCatalogType: undefined,
  isOpen: false,
  flags: {
    isSettingEcommerceType: false,
  }
};

export default function CatalogSelectionReducer(
  state: ICatalogSelectionState = initialState,
  action: CatalogSelectionModalAction,
): ICatalogSelectionState {
  switch ( action.type ) {
    case CATALOG_SELECTION_MODAL_ACTIONS.CHANGE_CATALOG_TYPE:
      return {
        ...state,
        selectedCatalogType: action.catalogType,
      };
    case CATALOG_SELECTION_MODAL_ACTIONS.OPEN_MODAL:
      return {
        ...state,
        isOpen: true,
      };
    case CATALOG_SELECTION_MODAL_ACTIONS.CLOSE_MODAL:
      return {
        ...state,
        isOpen: false,
      };
    case CATALOG_SELECTION_MODAL_ACTIONS.SET_SELECTED_ECOMMERCE_TYPE:
      return {
        ...state,
        flags: {
          isSettingEcommerceType: true,
        },
      };
    case CATALOG_SELECTION_MODAL_ACTIONS.RECEIVE_SELECTED_ECOMMERCE_TYPE:
      return {
        ...state,
        flags: {
          isSettingEcommerceType: false,
        },
      };
    default:
      return state;
  }
}
